import React from 'react'
import { hashHistory } from 'react-router'
import { Box, Tabs, Tab } from '@mui/material'
import ButtonInc from '../../../../../shared-ui/ButtonInc'
import ServerPagedTable from '../../../shared/ServerPagedTable'
import { groupStatusLabel, groupStatusTone } from '../../lib/groupStatus'

// The status values are the backend filter; the labels are display-only and
// derive from the same helper the pills use, so the "registered" tab reads
// "Pending Verification" without changing the status the table queries for.
const TAB_STATUSES = ['pending_registration', 'registered', 'endorsed']
const TAB_LABELS = TAB_STATUSES.map(groupStatusLabel)

const headerCard = {
  background: '#FFFFFF',
  borderRadius: '8px',
  padding: '18px 20px'
}

const titleStyle = {
  fontFamily: 'Lato',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.0015em',
  color: '#000000',
  margin: 0
}

const tabsSx = {
  '& .MuiTabs-indicator': {
    backgroundColor: '#032A37'
  },
  '& .MuiTab-root': {
    fontFamily: 'Open Sans',
    textTransform: 'capitalize',
    fontSize: '13px',
    color: '#000000'
  },
  '& .MuiTab-root.Mui-selected': {
    color: '#fff',
    background: '#032A37',
    borderRadius: '8px 8px 0px 0px'
  }
}

function StatusPill(props) {
  const tone = groupStatusTone(props.status)
  let bg = '#DAE3E7'
  let color = '#8D8D8C'
  if (tone === 'positive') {
    bg = '#CCFFDD'
    color = '#0A7D3A'
  } else if (tone === 'negative') {
    bg = '#FDE2E2'
    color = '#8F191C'
  }
  return (
    <span
      style={{
        background: bg,
        color,
        borderRadius: '10px',
        padding: '3px 12px',
        fontSize: '11px',
        fontFamily: 'Open Sans',
        fontWeight: 600,
        display: 'inline-block'
      }}
    >
      {groupStatusLabel(props.status)}
    </span>
  )
}

class GroupsList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tabIndex: 0
    }
    this.handleTabChange = this.handleTabChange.bind(this)
    this.fetchPage = this.fetchPage.bind(this)
  }

  // Only the tab moves here; the table owns the page and the page size and
  // asks for the first page of the newly selected status itself.
  handleTabChange(event, newIndex) {
    this.setState({ tabIndex: newIndex })
  }

  fetchPage(page, limit) {
    this.props.getGroups({
      status: TAB_STATUSES[this.state.tabIndex],
      page,
      limit
    })
  }

  render() {
    const groups = this.props.groups
    const data = groups && groups.data ? groups.data : []
    const total = groups ? groups.total : null
    // The page the rows on screen came from, echoed back by /api/groups, so the
    // footer cannot describe a page that was requested but never arrived.
    const page = groups ? groups.page : null

    const columns = [
      { title: 'Group Number', field: 'group_number' },
      { title: 'Group Name', field: 'group_name' },
      { title: 'Type', field: 'group_type' },
      { title: 'Category', field: 'group_category' },
      {
        title: 'Status',
        field: 'status',
        render(rowData) {
          return <StatusPill status={rowData.status} />
        }
      },
      {
        title: 'Action',
        sorting: false,
        render(rowData) {
          return (
            <ButtonInc
              variant="contained"
              onClick={function() {
                hashHistory.push(`admin/group-detail/${rowData.guid}`)
              }}
            >
              View Group
            </ButtonInc>
          )
        }
      }
    ]

    return (
      <div>
        <section style={headerCard}>
          <h1 style={titleStyle}>Groups Dashboard</h1>
        </section>

        <Box
          sx={{ borderBottom: 1, borderColor: 'divider', marginTop: '16px' }}
        >
          <Tabs
            value={this.state.tabIndex}
            onChange={this.handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="groups dashboard"
            sx={tabsSx}
          >
            {TAB_LABELS.map(function(label, i) {
              return <Tab key={i} label={label} />
            })}
          </Tabs>
        </Box>

        <ServerPagedTable
          // The tab itself, not the status it maps to, so the reset does not
          // depend on every tab selecting a distinct status.
          resetKey={this.state.tabIndex}
          columns={columns}
          data={data}
          total={total}
          page={page}
          isLoading={this.props.loader}
          onFetch={this.fetchPage}
          options={{
            actionsColumnIndex: -1
          }}
          localization={{
            body: {
              emptyDataSourceMessage: 'No groups found'
            }
          }}
        />
      </div>
    )
  }
}

export default GroupsList
